"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthDenied = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const Button_1 = __importDefault(require("../Util/Button"));
// cant use withJourney due to circular deps
const AuthDenied = (props) => (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props, { className: 'j-auth-denied' })),
    react_1.default.createElement("span", null, "You are not authorized to access this page."),
    react_1.default.createElement(Button_1.default, { href: "/login" }, "Login")));
exports.AuthDenied = AuthDenied;
